import React, { useState } from "react";

function ExportDocxModal({ open, onExport, onCancel }) {
  const [includeHeaders, setIncludeHeaders] = useState(true);
  const [includeTiming, setIncludeTiming] = useState(true);

  if (!open) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-30">
      <div className="bg-white rounded-lg shadow-lg p-6 min-w-[300px]">
        <div className="text-lg font-semibold mb-2">Export to Docx</div>
        <hr className="border-gray-200 mb-4" />
        <div className="flex flex-col gap-4">
          <label className="flex flex-col gap-1 text-sm font-semibold text-gray-700">
            <span className="flex items-center gap-2">
              <input
                type="checkbox"
                checked={includeHeaders}
                onChange={(e) => setIncludeHeaders(e.target.checked)}
                className="font-normal"
              />
              Include bit headers
            </span>
            <span className="text-xs text-gray-400 font-normal">
              Adds a heading for each bit
            </span>
          </label>
          <label className="flex flex-col gap-1 text-sm font-semibold text-gray-700">
            <span className="flex items-center gap-2">
              <input
                type="checkbox"
                checked={includeTiming}
                onChange={(e) => setIncludeTiming(e.target.checked)}
                className="font-normal"
              />
              Include timing
            </span>
            <span className="text-xs text-gray-400 font-normal">
              Adds the start/end time for each bit, and a total time at the
              end
            </span>
          </label>
        </div>
        <div className="flex gap-4 justify-end mt-4">
          <button
            type="button"
            onClick={onCancel}
            className="bg-gray-300 text-gray-800 font-semibold py-2 px-4 rounded-lg hover:bg-gray-200 transition"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={() => onExport({ includeHeaders, includeTiming })}
            className="bg-yellow-400 text-green-900 font-semibold py-2 px-4 rounded-lg hover:bg-yellow-300 transition"
          >
            Export
          </button>
        </div>
      </div>
    </div>
  );
}

export default ExportDocxModal;
